/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function () {
  function isAsyncFeedbackForm(form) {
    if (!form || form.tagName !== 'FORM') {
      return false;
    }

    var hasContactEmail = Boolean(form.querySelector('input[name="contact[email]"]'));
    var hasContactBody = Boolean(form.querySelector('textarea[name="contact[body]"]'));
    var hasNewsletterTag = Boolean(form.querySelector('input[name="contact[tags]"][value*="newsletter"]'));

    return hasContactEmail && (hasContactBody || hasNewsletterTag);
  }

  function injectSubmitFeedbackStyles() {
    if (document.getElementById('mstar-submit-feedback-style')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'mstar-submit-feedback-style';
    style.textContent = '.mstar-submit-is-loading{opacity:.72;cursor:wait!important;pointer-events:none}.mstar-submit-is-loading[disabled]{opacity:.72}';
    document.head.appendChild(style);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!isAsyncFeedbackForm(form)) {
      return;
    }

    if (form.dataset.mstarSubmitting === 'true') {
      event.preventDefault();
      return;
    }

    var submitButton = form.querySelector('button[type="submit"], input[type="submit"]');

    if (!submitButton) {
      return;
    }

    injectSubmitFeedbackStyles();
    form.dataset.mstarSubmitting = 'true';
    submitButton.classList.add('mstar-submit-is-loading');
    submitButton.setAttribute('aria-busy', 'true');
    submitButton.disabled = true;

    var loadingText = form.querySelector('textarea[name="contact[body]"]') ? 'Submitting...' : 'Subscribing...';

    if (submitButton.tagName === 'BUTTON') {
      submitButton.dataset.originalText = submitButton.textContent;
      submitButton.textContent = loadingText;
    } else {
      submitButton.dataset.originalValue = submitButton.value;
      submitButton.value = loadingText;
    }
  }, true);
}());
